//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    tab: {
      default: ''
    }
  },
  data: () => ({
    search: {
      q: undefined
    },
    table: [],
    loading: false
  }),
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'pickPoint') {
          this.handleLoadTableData()
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search)
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/dealer/pick/point/list', { params: data }).then(res => {
        // console.log('res', res)
        this.table = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
